// extracted by mini-css-extract-plugin
module.exports = {"container":"DashboardOpenButton_container__2axfB","icon-update":"DashboardOpenButton_icon-update__fkUdx"};